import axios from "axios";
import { useEffect, useState } from "react";
import DashboardCard from "../Components/DashboardCard";
import "../styles/dashboard.css";

export default function Dashboard() {
  const [values, setValues] = useState({});
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_LOCAL_API_URL}/admin/dashboard`)
      .then((res) => {
        //console.log(res.data);
        setValues(res.data);
      })
      .catch((err) => {
        console.log("error" + err.message);
      });
  }, []);
  return (
    <>
      <h1>Dashboard</h1>
      <div className="dashboard-grid">
        <DashboardCard
          title="Revenue Today"
          value={`ETB ${values.revenueToday}`}
        />
        <DashboardCard title="Orders Today" value={values.ordersToday} />
        <DashboardCard title="Active Branches" value={values.activeBranches} />
      </div>
    </>
  );
}
